module.exports = __webpack_public_path__ + "static_pc/img/5.c47d8ffe.png";